<template>
  <v-container
    fluid
    :class="{
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode,
      isBlocked: !editMode,
    }"
  >
    <!--<loading v-if="!isLoaded"/>-->
    <v-layout row wrap>
      <v-flex xs12 owners>
        <v-layout row wrap v-if="!ownersData || !ownersData.length">
          <v-flex xs12>
            <h2 class="empty_title">
              {{ $t("components.client.owners.empty") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12>
            <table>
              <template
                v-if="ownerCompanies !== undefined && ownerCompanies.length"
              >
                <tr>
                  <td colspan="4">
                    <h3>
                      {{
                        $t("components.client.owners.table.fields.companies")
                      }}
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th>
                    {{
                      $t("components.client.owners.table.fields.proportion")
                    }}
                  </th>
                  <th>
                    {{ $t("components.client.owners.table.fields.name") }}
                  </th>
                  <th>
                    {{ $t("components.client.owners.table.fields.place") }}
                  </th>
                  <th></th>
                </tr>
                <tr v-for="(item, idx) in ownerCompanies" :key="'legal_' + idx">
                  <td>{{ item.percentage }}%</td>
                  <td @click="editOwner(item)" class="item-name">
                    {{ item.legal_person_name }}
                  </td>

                  <td>{{ item.legal_person_location }}</td>

                  <td class="table-actions">
                    <div class="table-actions__buttons text-right">
                      <v-btn
                        text
                        icon
                        @click="editOwner(item)"
                        :disabled="!editMode"
                        class="ma-0 pa-0"
                      >
                        <v-icon color="warning" size="20px">edit</v-icon>
                      </v-btn>
                      <!-- <v-btn
                                                text
                                                icon
                                                @click="deleteEntry(item)"
                                                :disabled="!editMode"
                                                class="ma-0 pa-0"
                                            >
                                                <v-icon color="error" size="20px">delete</v-icon>
                                            </v-btn>-->
                      <delete-dialog
                        :deleteButton="{
                          type: 'icon',
                          value: 'delete',
                          disabled: !editMode,
                        }"
                        :item-name="item.name"
                        v-on:deleteEntry="deleteEntry(item)"
                      />
                    </div>
                  </td>
                </tr>
              </template>

              <template
                v-if="ownerPersons !== undefined && ownerPersons.length"
              >
                <tr>
                  <td colspan="4">
                    <h3>
                      {{ $t("components.client.owners.table.fields.users") }}
                    </h3>
                  </td>
                </tr>

                <tr>
                  <th>
                    {{
                      $t("components.client.owners.table.fields.proportion")
                    }}
                  </th>
                  <th>
                    {{ $t("components.client.owners.table.fields.full_name") }}
                  </th>
                  <th>
                    {{ $t("components.client.owners.table.fields.regAddress") }}
                  </th>
                  <th></th>
                </tr>
                <tr v-for="(item, idx) in ownerPersons" :key="'person_' + idx">
                  <td>{{ item.percentage }}%</td>
                  <td @click="editOwner(item)" class="item-name">
                    {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                  </td>
                  <td>{{ item.document_reg_address }}</td>

                  <td class="table-actions">
                    <div class="table-actions__buttons text-right">
                      <v-btn
                        text
                        icon
                        @click="editOwner(item)"
                        :disabled="!editMode"
                        class="ma-0 pa-0"
                      >
                        <v-icon color="warning" size="20px">edit</v-icon>
                      </v-btn>
                      <delete-dialog
                        :deleteButton="{
                          type: 'icon',
                          value: 'delete',
                          disabled: !editMode,
                          iconColor: 'error',
                        }"
                        :item-name="item.name"
                        v-on:deleteEntry="deleteEntry(item)"
                      />
                    </div>
                  </td>
                </tr>
              </template>
            </table>
          </v-flex>
        </v-layout>
        <span
          @click="createNewOwner"
          class="add-link"
          v-if="!packageMode || editMode"
        >
          <v-icon>add</v-icon>{{ $t("components.client.owners.add") }}
        </span>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="createOwner"
      transition="slide-x-reverse-transition"
      content-class="halfscreen"
      persistent
    >
      <add-owner
        v-on:updateOwners="updateOwners"
        v-on:addOwner="addOwner"
        v-on:closeModal="closeModal"
        :maxPercentage="maxPercentage"
        :editedOwner="owner"
        :create="create"
        :editMode="editMode"
        :packageMode="packageMode"
        :agentMode="agentMode"
        :publicHash="publicHash"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import AddOwner from "@/components/clients/add/owner";
import DeleteDialog from "@/components/lib/DeleteDialog";

export default {
  name: "ClientOwners",
  data: () => ({
    isLoaded: false,
    createOwner: false,
    valid: false,
    create: null,
    owner: {},
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    ownersData: {
      type: Array,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AddOwner,
    DeleteDialog,
  },
  computed: {
    ownerPersons() {
      return this.ownersData.filter((item) => !item.is_legal_person);
    },
    ownerCompanies() {
      return this.ownersData.filter((item) => item.is_legal_person);
    },
    maxPercentage() {
      let maxPercentage = 100;

      if (this.ownersData.length) {
        this.ownersData.map(
          (item) => (maxPercentage -= Number(item.percentage))
        );
      }
      return maxPercentage;
    },
  },
  methods: {
    updateOwners(owner) {
      this.$emit("updateOwners", owner);
      this.createOwner = false;
      this.owner = null;
      this.create = null;
    },
    addOwner(owner) {
      this.$emit("addOwner", owner);
      this.createOwner = false;
      this.owner = null;
      this.create = null;
    },
    async deleteEntry(item) {
      const index = this.ownersData.indexOf(item);

      const url = this.publicHash
        ? `v1/founders/${item.id}/delete-by-hash/${this.publicHash}`
        : `v1/founders/${item.id}/delete`;

      if (this.packageMode && !this.publicHash) {
        this.ownersData.splice(index, 1);
      } else {
        await apiCallTrue({
          url,
          method: "POST",
        })
          .then(() => {
            this.ownersData.splice(index, 1);
          })
          .catch(() => console.log("not deleted"));
      }
    },

    editOwner(owner) {
      this.owner = Object.assign({}, owner);
      this.createOwner = true;
      this.create = false;
    },
    closeModal() {
      this.createOwner = false;
      this.create = null;
    },
    createNewOwner() {
      this.owner = Object.assign({}, this.newOwner);
      this.create = true;
      this.createOwner = true;
    },
  },
};
</script>

<style scoped>
#app .v-menu__content {
  box-shadow: 0 0 0;
}
</style>
